import styled from "styled-components";
import * as h from "../../_themes/helpers";

export const Input: any = styled.input`
  display: none;

  @media (hover: hover) {
    &:hover ~ label {
      background: ${h.getHoverColor(
        "settingToggleBackground",
        "settingToggle.background"
      )};
    }

    &::after {
      background: ${h.getHoverColor(
        "settingToggleButton",
        "settingToggle.button"
      )};
    }
  }

  &:active ~ label {
    background: ${h.getPressedColor(
      "settingToggleBackground",
      "settingToggle.background"
    )};

    &::after {
      background: ${h.getPressedColor(
        "settingToggleButton",
        "settingToggle.button"
      )};
    }
  }

  &[data-checked="true"] ~ label {
    background: ${h.getActiveColor(
      "settingToggleBackground",
      "settingToggle.background"
    )};

    &::after {
      left: 48.82%;
      background: ${h.getActiveColor(
        "settingToggleButton",
        "settingToggle.button"
      )};
    }
  }

  &:disabled ~ label {
    background: ${h.getDisabledColor(
      "settingToggleBackground",
      "settingToggle.background"
    )};
    pointer-events: none;

    &::after {
      background: ${h.getDisabledColor(
        "settingToggleButton",
        "settingToggle.button"
      )};
    }
  }

  &[data-checked="true"]:disabled ~ label {
    opacity: 0.5;
    background: ${h.getActiveColor(
      "settingToggleBackground",
      "settingToggle.background"
    )};

    &::after {
      background: ${h.getActiveColor(
        "settingToggleButton",
        "settingToggle.button"
      )};
    }
  }
`;
